import type { LgpdConsentimento, LgpdSolicitacao, RegistrarConsentimentoCommand } from '@/domain/model/Lgpd';
import type { LgpdGateway } from '@/application/port/out/LgpdGateway';
import type {
  ExportarDadosLgpdUseCase, SolicitarExclusaoLgpdUseCase,
  ListConsentimentosUseCase, RegistrarConsentimentoUseCase,
} from '@/application/port/in/LgpdUseCase';

export class ExportarDadosLgpd implements ExportarDadosLgpdUseCase {
  constructor(private readonly g: LgpdGateway) {}
  execute(): Promise<unknown> { return this.g.exportarDados(); }
}
export class SolicitarExclusaoLgpd implements SolicitarExclusaoLgpdUseCase {
  constructor(private readonly g: LgpdGateway) {}
  execute(motivo: string | null): Promise<LgpdSolicitacao> { return this.g.solicitarExclusao(motivo); }
}
export class ListConsentimentos implements ListConsentimentosUseCase {
  constructor(private readonly g: LgpdGateway) {}
  execute(): Promise<LgpdConsentimento[]> { return this.g.listConsentimentos(); }
}
export class RegistrarConsentimento implements RegistrarConsentimentoUseCase {
  constructor(private readonly g: LgpdGateway) {}
  execute(cmd: RegistrarConsentimentoCommand): Promise<LgpdConsentimento> { return this.g.registrarConsentimento(cmd); }
}
